export const dealIntegrationConfiguration = {
  formName: 'deal-integration-configuration',
  title: null,
  backUrl: null,
  endpoint: '/organizations/${this.params.id}/attributes',
  createEndpoint: null,
  fields: [
    {
      name: 'id',
      interface: 'hidden',
      type: 'integer',
      label: '',
      hint: '',
      required: false,
      validation: null,
    },
    {
      name: 'Title',
      interface: 'label',
      type: 'string',
      label: `<h2>Deal Integration Settings</h2>`,
      hint: '',
      required: false,
      validation: null,
    },
    {
      name: 'dealcloud_client_url',
      interface: 'textbox',
      type: 'string',
      label: 'DealCloud Client URL',
      hint: '',
      required: false,
      validation: null,
    },
    {
      name: 'dealcloud_client_id',
      interface: 'textbox',
      type: 'string',
      label: 'Client ID',
      hint: '',
      required: false,
      validation: null,
    },
    {
      name: 'dealcloud_client_secret',
      interface: 'textbox',
      type: 'string',
      label: 'Client Secret',
      hint: '',
      required: false,
      validation: null,
      password: true,
    },
    {
      name: 'dealcloud_create_mode',
      interface: 'select',
      type: 'string',
      label: 'Create Mode',
      options: () => {
        return [
          {
            name: 'Create Property',
            value: 'create_property',
          },
          {
            name: 'Create Property + Deal',
            value: 'create_property_and_deal',
          },
        ];
      },
      required: false,
      validation: null,
    },
    {
      name: 'dealcloud_mapping_config',
      interface: 'textbox',
      type: 'string',
      multiline: true,
      rows: 4,
      label: 'Object & Field Mapping Configuration',
      hint: '',
      required: false,
      validation: null,
    },
  ],
};
